import type { Props } from './Svg'
import { Svg } from './Svg'

export function SubtractIcon(props: Props) {
  return (
    <Svg width="32" height="33" fill="none" stroke="none" {...props}>
      <path
        fill="currentColor"
        d="M18.21 14.026c3.49-.858 5.843-3.698 5.843-6.763S21.7 1.358 18.21.5v13.526Zm.264 4.684c.858 3.49 3.698 5.843 6.763 5.843S31.142 22.2 32 18.71H18.474ZM7.947 25.738c0-3.065 2.352-5.905 5.843-6.763V32.5c-3.491-.858-5.843-3.698-5.843-6.763ZM0 14.29h13.526c-.858-3.491-3.698-5.843-6.763-5.843S.858 10.8 0 14.29Z"
      />
    </Svg>
  )
}
